/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 20/12/2022
 */
import BaseObject from "@shared/BaseObject.js";
import dayjs from "dayjs"

export default class RecurringData extends BaseObject {

	installmentsTotal: number = 0
	installmentsPaid: number = 0
	recurringAmount: number = 0
	repeatInterval: number = 0
	intervalLength: string = null

	subInvoices = []

	stripeProductId: string = null
	stripePriceId: string = null
	stripeSubscriptionId: string = null
	stripeInvoiceIdLatest: string = null


	constructor() {
		super();
	}

	setPaid(paidDateTs, paidWith){
		this.subInvoices.push({
			paidDateTs,
			paidWith,
		})
		this.installmentsPaid++
	}

	isFullyPaid(){
		return this.installmentsPaid >= this.installmentsTotal
	}

	getNextRenewalTs(){
		return dayjs().add(this.repeatInterval, this.intervalLength).valueOf()
	}


}
